import styled from 'styled-components';

export const ValueText = styled.span`
  fuel-typography > p {
    text-decoration: line-through;
  }
`;
